"use client";

import { usePathname } from "next/navigation";
import type { ReactNode } from "react";
import { SiteFooter } from "@/components/layout/site-footer";
import { SiteHeader } from "@/components/layout/site-header";
import { NewsletterSection } from "@/components/sections/newsletter-section";
import { isLightPage } from "@/lib/light-pages";

export function PageShell({
  children,
  copyrightYear,
}: {
  children: ReactNode;
  copyrightYear: number;
}) {
  const pathname = usePathname();
  const lightPage = isLightPage(pathname);
  const surfaceClass = lightPage
    ? "bg-[#f3f3f3]"
    : "bg-(--color-background-strong)";

  return (
    <div className={`flex min-h-dvh flex-col ${surfaceClass}`}>
      <SiteHeader />
      <main
        className={`flex-1 ${surfaceClass}`}
        style={{ paddingTop: "calc(5rem + env(safe-area-inset-top))" }}
      >
        {children}
      </main>
      <NewsletterSection />
      <SiteFooter copyrightYear={copyrightYear} />
    </div>
  );
}
